import { removeCommas } from '@ps-smart-cp/ppfw-client';
import Decimal from 'decimal.js';

function calculateTotal<T>(propName: keyof T, objArray: T[]) {
  if (objArray.length > 0) {
    return objArray
      .reduce((total, item) => {
        const targetValue = Number.isNaN(Number(removeCommas(item[propName] as string)))
          ? 0
          : Number(removeCommas(item[propName] as string));
        return total + targetValue;
      }, 0)
      .toLocaleString();
  }
  return '0';
}

function calculateTotalDecimal<T>(propName: keyof T, objArray: T[]) {
  if (objArray.length > 0) {
    return objArray
      .reduce((total, item) => {
        const value = removeCommas(item[propName] as string);
        const targetValue = Number.isNaN(Number(value)) || value === '' ? Decimal(0) : Decimal(value);
        return Decimal(total).add(targetValue);
      }, Decimal(0))
      .toLocaleString();
  }
  return '0';
}

//TODO: PPBOSにマージするときに競合が発生した場合は削除予定です。
function subtract(minuend: string, ...subtrahends: string[]) {
  return subtrahends.reduce(
    (accumulator, currentValue) =>
      (Number(removeCommas(accumulator)) - Number(removeCommas(currentValue))).toLocaleString(),
    minuend,
  );
}

function calculateDelta(minuend: string, subtrahend: string) {
  return (Number(removeCommas(minuend)) - Number(removeCommas(subtrahend))).toLocaleString();
}

function calculateDeltaDecimal(minuend: string, subtrahend: string) {
  return Decimal(Number(removeCommas(minuend)))
    .sub(Decimal(Number(removeCommas(subtrahend))))
    .toLocaleString();
}

function toNumber(item: string) {
  return Number.isNaN(Number(removeCommas(item))) ? 0 : Number(removeCommas(item));
}

export { calculateDelta, calculateDeltaDecimal, calculateTotal, calculateTotalDecimal, subtract, toNumber };
